// extracted by mini-css-extract-plugin
export default {"text_container":"GameMode_text_container__9ffxL","back_btn":"GameMode_back_btn__664Jw","back_icon":"GameMode_back_icon__OSzRE","text":"GameMode_text__n0EPo"};